import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { Student } from "@/types/user.types";
import { AddStudentModal } from "./AddStudentModal";


interface RelatedStudentsProps {
  students: Student[];
  handleAddStudent: (student: Student) => void;
  handleDeleteStudent: (id: string) => void;
}

const RelatedStudents: React.FC<RelatedStudentsProps> = ({ handleAddStudent, handleDeleteStudent, students
}) => {
  const [openModal, setOpenModal] = useState(false);

  const [errors, setErrors] = useState({
    name: "",
    id: "",
  });

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setErrors({ name: "", id: "" });
  };


  return (
    <Box sx={{ mb: 3 }}>
      {/* Header con botón */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            color: "#333",
            fontSize: "0.95rem",
          }}
        >
          Estudiantes Relacionados
        </Typography>
        <Button
          variant="contained"
          onClick={handleOpenModal}
          sx={{
            backgroundColor: "primary.dark",
            color: "#fff",
            textTransform: "none",
            px: 3,
            py: 0.8,
            fontSize: "0.85rem",
            fontWeight: 600,
            height: "30px",
            borderRadius: "6px",
            "&:hover": {
              backgroundColor: "#0f1923",
            },
          }}
        >
          Agregar
        </Button>
      </Box>

      {/* Tabla de estudiantes con scroll */}
      {students.length > 0 && (
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            overflow: "hidden",
            maxHeight: "240px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header de la tabla - fijo */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 40px",
              gap: 2,
              p: 2,
              backgroundColor: "#f5f5f5",
              borderBottom: "1px solid #e0e0e0",
              position: "sticky",
              top: 0,
              zIndex: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, color: "#555", fontSize: "0.9rem" }}
            >
              Nombre
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, color: "#555", fontSize: "0.9rem" }}
            >
              ID
            </Typography>
            <Box />
          </Box>

          {/* Contenedor con scroll para las filas */}
          <Box
            sx={{
              overflowY: "auto",
              flex: 1,
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f5f5f5",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c1c1c1",
                borderRadius: "4px",
                "&:hover": {
                  backgroundColor: "#a8a8a8",
                },
              },
            }}
          >
            {/* Filas de estudiantes */}
            {students.map((student) => (
              <Box
                key={student.id}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 40px",
                  gap: 2,
                  p: 2,
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  "&:last-child": {
                    borderBottom: "none",
                  },
                  "&:hover": {
                    backgroundColor: "#fafafa",
                  },
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "#333", fontSize: "0.9rem" }}
                >
                  {student.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", fontSize: "0.9rem" }}
                >
                  {student.id}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => handleDeleteStudent(student.id)}
                  sx={{
                    color: "#666",
                  }}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Paper>
      )}

      <AddStudentModal openModal={openModal} handleAddStudent={handleAddStudent} handleCloseModal={handleCloseModal} setErrors={setErrors} errors={errors} />
    </Box>
  );
};

export default RelatedStudents;